import React from "react";
import { NavLink, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearSuperadminRefreshToken } from "../../redux-toolkit/reducer/superadminRefreshToken_reducer";
import "../../superadminstyle.module.css";
import { GiHamburgerMenu } from "react-icons/gi";
import cx from "./header.module.css";
import { httpSuperAdmin } from "../../Apis/commonApis";

const redirectUrl = process.env.REACT_APP_REDIRECTION_URL_PLAN;

function Header() {
  const history = useHistory();
  const dispatch = useDispatch();
  let roleAccess = JSON.parse(localStorage.getItem("__csadmin__d"));
  async function verifyLogout() {
    const response = await httpSuperAdmin("logout", {});
    // Clear refresh tokens from Redux store and localStorage
    dispatch(clearSuperadminRefreshToken());

    // Clear other tokens from localStorage
    localStorage.removeItem("currentCareSiteId");
    localStorage.removeItem("superadmin_token");
    localStorage.removeItem("superadmin_access_token_expiry");
    localStorage.removeItem("superadmin_refresh_token");
    localStorage.removeItem("__csadmin__d");

    // Redirect to login page
    history.replace("/superadmin/login");
  }
  return (
    <>
      <header className={`topbar ${cx.superAdminHeader}`}>
        <nav className="navbar top-navbar navbar-expand-md navbar-dark">
          <div className="navbar-header">
            <button className="hemburger_menu">
              <GiHamburgerMenu />
            </button>
            <a className="navbar-brand" href={redirectUrl}>
              <b className="logo-icon">
                <img
                  style={{ width: "110px", transition: "none" }}
                  alt=""
                  src={`/admin/images/logo2.svg`}
                />
              </b>
            </a>
            <NavLink
              className="topbartoggler d-block d-md-none waves-effect waves-light"
              to="/superadmin/dashboard"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <i className="ti-more"></i>
            </NavLink>
          </div>
          <div className="navbar-collapse collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto">
              <h4>Hello! {roleAccess?.firstName}</h4>
            </ul>
            <ul className="navbar-nav">
              <li className="nav-item dropdown create_list">
                <NavLink
                  className="nav-link waves-effect waves-dark"
                  to="#"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {roleAccess?.userType?.split("")?.[0]?.toUpperCase() +
                    roleAccess?.userType?.slice(1)}
                </NavLink>
              </li>

              <li className="nav-item dropdown profile">
                <NavLink
                  className="nav-link dropdown-toggle waves-effect waves-dark"
                  to="#"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <img
                    // src={`/admin/images/profle.jpg`}
                    src={roleAccess?.image}
                    alt=""
                    className="profile-pic rounded-circle"
                    style={{
                      height: "30px",
                      width: "30px",
                      objectFit: "cover",
                    }}
                  />
                </NavLink>
                <div className="dropdown-menu dropdown-menu-end user-dd animated flipInY">
                  <div className="d-flex no-block align-items-center p-3 bg-info text-white mb-2">
                    <div className="">
                      <img
                        // src={`/admin/images/profle.jpg`}
                        src={roleAccess?.image}
                        alt="user"
                        className="rounded-circle"
                        style={{
                          height: "50px",
                          width: "50px",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                    <div className="ms-2">
                      <h4 className="mb-0 text-white">
                        {roleAccess?.firstName} {roleAccess?.lastName}
                      </h4>
                      <p className=" mb-0">{roleAccess?.email}</p>
                    </div>
                  </div>
                  <NavLink className="dropdown-item" to="/superadmin/profile">
                    Profile
                  </NavLink>
                  <div className="dropdown-divider"></div>
                  <div className="pl-4 p-2">
                    <button
                      type="button"
                      className="btn d-block w-100 btn-info rounded-pill"
                      onClick={() => verifyLogout()}
                    >
                      Logout
                    </button>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </nav>
      </header>
    </>
  );
}
export default Header;
